import React, { useState, useEffect, } from 'react'
import Modal from 'react-modal'
import joystickLogo from "../../../assets/images/joystick-logo.png"
import ErrorComponent from '../../layouts/ErrorComponent'
import "./LoginModalComponent.scss"
import Loading from '../../layouts/Loading'
import { useDispatch, useSelector, } from 'react-redux'
import { authorise, } from '../../../redux/actions/authActions'
import { login, } from '../../../redux/actions/authActions'

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '550px',
    borderRadius: '10px',
    height: "auto",  
  },
}

Modal.setAppElement('#app')

const LoginModalComponent = ({ modalIsOpen, closeModal, }) => {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  
  const dispatch = useDispatch()
  const state = useSelector(state => ({
    auth: state.auth,
  }))

  useEffect(() => {
    if (959 >= window.innerWidth) {
      customStyles.content.top = '50%'
      customStyles.content.width = '400px'
      customStyles.content.height = "500px" 
    }
    setLoading(false)
    dispatch(authorise())
  }, [])
  
  useEffect(() => {
    if (false === state.auth.loading) {
      if (null !== state.auth.data) {
        setUsername("")
        setPassword("")
        setError(null)
        setLoading(false)
        closeModal()
      }
    }
  }, [state.auth])
  
  const onFormSubmit = async (e) => {
    e.preventDefault()

    await dispatch(login({ username, password, }))
  }

  const onUsernameChange = (e) => {
    setUsername(e.target.value)
  }

  const onPasswordChange = (e) => {
    setPassword(e.target.value)
  }

  const handleCloseModal = () => {
    setUsername("")
    setPassword("")
    setError(null)
    closeModal()
  }

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={() => {}}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Log In Modal"
        onAfterClose={handleCloseModal}
      >
        {(loading || state.auth.loading) ? (
          <div className="text-center mb-6">
            <Loading/>
          </div>
        ) : (
          <form method="post" onSubmit={onFormSubmit}>
            <div className="text-center">
              <a href="/">
                <img src={joystickLogo} alt="Joystick Logo" className="mb-4" style={{ width: '50px', }}/>
              </a>
              <h2>Log In</h2>
              <hr/>
              <ErrorComponent error={error || state.auth.error}/>
              <div className="row mb-3">
                <label htmlFor="username" className="col-sm-2 col-form-label">Username</label>
                <div className="col-sm-10">
                  <input type="text" className="form-control" id="username" placeholder='Enter your username...' value={username} onChange={onUsernameChange} autoComplete='on'/>
                </div>
              </div>
              <div className="row mb-3">
                <label htmlFor="password" className="col-sm-2 col-form-label">Password</label>
                <div className="col-sm-10">
                  <input type="password" className="form-control" id="password" placeholder="Enter your password..." value={password} onChange={onPasswordChange}/>
                </div>
              </div>
            </div>
            <div className="d-flex mt-4 justify-content-between">
              <div className="text-start">
                <button className='btn joystick-btn' onClick={handleCloseModal} type="button">Cancel</button>
              </div>
              <div className="text-end">
                <button className='btn joystick-success' type="submit">Submit</button>
              </div>
            </div>
          </form>
        )}
      </Modal>
    </div>
  )
}

export default LoginModalComponent